<div class="container-fluid">
  <div class="add-note-heading">
    <div class="note-heading-text-container">
      <img src="../../../../../assets/svg/MyReportees-icon.svg" width="30px" />
      <div>
        {{
          action === "edit"
            ? "Edit Note"
            : action === "view" && isUserView
            ? getNoteTypeLabel(noteSearch)
            : action === "view"
            ? "View Note"
            : "Add Note"
        }}
      </div>
    </div>
    <div>
      <img
        *ngIf="!isViewMode"
        class="close-icon-svg"
        (click)="openConfirmationDialog()"
        src="assets/icons/dashboard-icons/close-pink-icon.svg"
      />
      <img
        *ngIf="isViewMode"
        class="close-icon-svg"
        (click)="closeDialog()"
        src="assets/icons/dashboard-icons/close-pink-icon.svg"
      />
    </div>
  </div>

  <div>
    <form #noteForm="ngForm" (ngSubmit)="Submit(noteForm)" novalidate>
      <div class="note-date-container">
        <!-- Date Field -->
        <div class="date-note-by-box">
          <mat-form-field appearance="outline" class="example-full-width w-100">
            <mat-label class="common-heading"
              >Date <span class="contentRed"></span
            ></mat-label>
            <input
              matInput
              [matDatepicker]="picker"
              placeholder="dd/mm/yyyy"
              autocomplete="off"
              [(ngModel)]="selectedDate"
              name="selectedDate"
              (dateChange)="onDateChange($event)"
              required
              [disabled]="isViewMode"
              [min]="minDate"
              [max]="maxDate"
              [matDatepickerFilter]="dateFilter"
            />

            <mat-datepicker-toggle
              matSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </div>

        <!-- Note By -->
        <div class="date-note-by-box">
          <mat-form-field appearance="outline" class="example-full-width w-100">
            <mat-label>
              <img src="\assets\svg\filter-icon.svg" />
              <span class="common-heading"> Note By</span>
            </mat-label>
            <mat-select
              [(ngModel)]="noteSearch"
              name="noteType"
              [disabled]="isViewMode"
              required
            >
              <mat-option
                *ngFor="let noteby of NoteByList"
                [value]="noteby.value"
              >
                <div
                  class="options"
                  #note
                  [matTooltip]="note.key | underScoreToSpace"
                >
                  {{ noteby.key | underScoreToSpace }}
                </div>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- <div class="note-title-box">
          <mat-form-field appearance="outline" class="example-full-width w-100">
            <mat-label class="common-heading"
              >Note Title <span class="contentRed"></span
            ></mat-label>
            <input
              matInput
              placeholder="Enter note title"
              autocomplete="off"
              [(ngModel)]="noteTitle"
              name="noteTitle"
              maxlength="100"
              required
              [disabled]="isViewMode"
            />
            <mat-hint align="end">{{ noteTitle?.length || 0 }}/100</mat-hint>
          </mat-form-field>
        </div> -->
      </div>
      <!-- Note title -->
      <div class="note-title">
        <div class="note-description-heading">Title:</div>
        <div class="note-title-input">
          <textarea
            class="custom-outlined-textarea"
            [(ngModel)]="noteTitle"
            [class.invalid-textarea]="noteForm.submitted && !noteTitle"
            name="noteTitle"
            maxlength="100"
            required
            [disabled]="isViewMode"
          ></textarea>
          <div class="note-title-mat-hint">
            <mat-hint align="end">{{ noteTitle?.length || 0 }}/100</mat-hint>
          </div>
        </div>
      </div>
      <!-- Note Description -->
      <div class="note-description">
        <div class="note-description-heading">Description:</div>
        <textarea
          class="custom-outlined-textarea"
          [(ngModel)]="noteDescription"
          [class.invalid-textarea]="noteForm.submitted && !noteDescription"
          name="noteDescription"
          required
          [disabled]="isViewMode"
        ></textarea>
      </div>
      <div class="submit-button" *ngIf="!isViewMode">
        <button
          class="blue-button"
          type="submit"
          [disabled]="isSubmitButtonDisabled"
        >
          {{
            isSubmitting
              ? action === "edit"
                ? "Updating..."
                : "Saving..."
              : action === "edit"
              ? "Update"
              : "Save"
          }}
        </button>
      </div>
    </form>
  </div>
</div>
